import {log, logAction} from "../../logging/logEvent";
import sort from "../sorting/sort";
import {setEarningsSortPriorityValues} from "../contribute/earnings/earnings";

export const CHOOSE_SORT = "CHOOSE_SORT";
export const CHOOSE_ROW = "CHOOSE_ROW";
export const INITIAL_STATE = {
    list: null,
    sort: { field: "latestActivity", reversed: false },
    selectedRow: null,
    failure: null
};

function sortStocks(sortCriteria, stocks, userIsWaiting) {
    const startTime = new Date().getTime();
    const sortedList = sort(sortCriteria)(stocks);
    const endTime = new Date().getTime();
    log("StocksSorted", { ...sortCriteria, elapsedTime: endTime - startTime, userIsWaiting: userIsWaiting });
    return sortedList;
}

const invertWord = (word) => {
    const alphabet = 'abcdefghijklmnopqrstuvwxyz';
    return word.split('').map(x => alphabet.charAt(25 - alphabet.indexOf(x)));
};

function addSortProperties(stocks) {
    return stocks.map(stock => {return {...stock,
        bloombergLowerCase: stock.bloomberg ? stock.bloomberg.toLowerCase() : null,
        totalIdeas: stock.openIdeas.longs + stock.openIdeas.shorts,
        nameLowerCase: stock.name ? stock.name.toLowerCase() : null,
        invertedNameLowerCase: stock.name ? invertWord(stock.name.toLowerCase()) : null,
        sentimentTodayValue: stock.sentiment ? (stock.sentiment.todayValue) : null,
        sentimentOneDayChange: stock.sentiment ? (stock.sentiment.oneDayChange) : null,
        priceChangeToday: stock.priceChangeToday ? Number.parseFloat(stock.priceChangeToday) : null,
        closestEarningsDateSortOrder: stock.earnings ? setEarningsSortPriorityValues(stock.earnings) : null
    }});
}

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case "SUBSCRIPTION_DATA_ARRIVED/STOCKS":
            const preparedStocks = addSortProperties(action.payload.stocks);
            return { ...state, list: sortStocks(state.sort, preparedStocks, action.userIsWaiting), failure: null };
        case "SUBSCRIPTION_DATA_FAILED/STOCKS":
            return { ...state, failure: action.payload };
        case CHOOSE_SORT:
            const sortCriteria = { field: action.field, reversed: ( state.sort.field === action.field ? !state.sort.reversed : false ) };
            return { ...state, list: sortStocks(sortCriteria, state.list, true), sort: sortCriteria, selectedRow: null };
        case CHOOSE_ROW:
            return { ...state, selectedRow: state.selectedRow === action.orgId ? null : action.orgId };
        default:
            return state;
    }
}

export default dispatch => ({
    changeSort(field) {
        dispatch({ type: CHOOSE_SORT, field: field });
    },
    selectRow(orgId) {
        dispatch(logAction({ type: CHOOSE_ROW, orgId: orgId }));
    }
});
